<template>
	<div id="planinbj">
		<HrrBreadcrumb PMname="岗位计划管理" CMname="京外调干岗位申报管理" />
		<HrrDetailLayout>
			<template slot="head" >
				{{title}}
			</template>
			<template slot="Form" >
				<el-form status-icon :model="form" ref="form" :rules="rules" label-width="220px" class="el-form-inbj" :hide-required-asterisk="!isAddOrEdit" >
					<el-form-item label="计划：" prop="planId">
                        <el-select v-model="form.planId"  placeholder="请选择" :disabled="!isAddOrEdit" >
                            <el-option v-for="item in planIdData" :key="item.planId" :label="item.planName" :value="item.planId" >
                            </el-option>
                        </el-select>
                    </el-form-item>
                    <el-form-item label="拟京外选调人员数量总数：" prop="totalNum">
						<el-input-number v-model="form.totalNum" controls-position="right" :min="0" v-if="isAddOrEdit" ></el-input-number>
						<span v-if="!isAddOrEdit">
							{{form.totalNum}}
						</span>
					</el-form-item>
                    <el-form-item label="其中符合绿色通道条件人员：" prop="greenNum">
                        <el-tooltip  placement="right">
                           <div slot="content">
                               <p>绿色通道条件：</p>
                                <li>1. 中国科学院和中国工程院院士；</li>
                               <li>2. 调任国家重点院校的院（系）主任；</li>
                               <li>3. 博士生导师；</li>
                               <li>4. 高新工程学科带头人；</li>
                               <li>5. 中科院“百人计划”人员；</li>
                               <li>6. 中科院创新岗位首席研究员；</li>
                               <li>7. 教育部“长江学者奖励计划”人员；</li>
                               <li>8. 九五以来获得国家级科技奖项人员；</li>
                               <li>9. 国家重点工程项目负责人；</li>
                           </div>
                    	   <el-input-number v-model="form.greenNum" controls-position="right" :min="0" v-if="isAddOrEdit" @blur="green()"></el-input-number>
                        </el-tooltip>
						<span v-if="!isAddOrEdit">
							{{form.greenNum}}
						</span>
					</el-form-item>
                    <el-form-item label="拟补充人员专业情况：">
                        <el-tag  :key="tag.id"  v-for="tag in dynamicTags"  closable  :disable-transitions="false"  @close="handleClose(tag)" v-if="isAddOrEdit" style="margin-right:10px;">
                          <span><span>{{tag.major}}</span><span >（{{tag.num}}人）</span></span>
                        </el-tag>
						<el-tag  :key="tag.id" v-for="tag in dynamicTags"   :disable-transitions="false"  v-if="!isAddOrEdit" style="margin-right:10px;">
                         	<span><span>{{tag.major}}</span><span >（{{tag.num}}人）</span></span>
                        </el-tag>
                        <template>
                            <el-form inline style="margin-top:20px;" :model="majorform" ref="majorform" :rules="majorrules">
                              <el-form-item prop="selectid">
                                <el-select v-model="majorform.selectid" placeholder="请选择专业" v-if="isAddOrEdit" ref="majors1" filterable>
                                    <el-option v-for="major in majors" :value="major.id" :label="major.name">{{major.name}}</el-option>
                                </el-select>
                              </el-form-item>
                              <el-form-item prop="num">
                                <el-input v-model="majorform.num" v-if="isAddOrEdit" style="width:90px;" placeholder="人数" ></el-input>
                              </el-form-item>
                              <el-form-item>
                                <el-button type="light-primary" @click="submitMajorForm('majorform')" v-if="isAddOrEdit">增加补充人员专业情况</el-button>
                              </el-form-item>
                            </el-form>
                        </template>
					</el-form-item>

				</el-form>
			</template>
			<template slot="buttons" >
				<el-button type="primary" @click="submitMForm('form')" v-if="isAddOrEdit">提 交</el-button>
				<el-button  @click="resetMForm('form')" v-if="isAddOrEdit">重 置</el-button>
				<el-button type="info" @click="returnMForm()" >返 回</el-button>
			</template>
		</HrrDetailLayout>
	</div>
</template>
<script>
	export default {
		name: 'plan_inbj_Detail',
		data(){
			return{
				form:{
					planId:"",
					inbjId:"",
					totalNum:0,
					greenNum:0,
					status:"",
				},
				majorform:{
					selectid:"",
					num:""
				},
				majorrules:{
					selectid:[ { required: true, message: '请选择专业' , trigger: 'blur'}],
					num:[ { required: true, message: '请填写数量' , trigger: 'blur'}]
				},
				rules:{
					planId:[ { required: true, message: '请选择计划' , trigger: 'blur'}],
					totalNum:[ { required: true, message: '拟京外选调人员数量总数' , trigger: 'blur'}],
					greenNum:[ { required: true, message: '其中符合绿色通道条件人员' , trigger: 'blur'}]
				},
				title:"",
				majors:[{id:1,name:"机械"},
	                {id:2,name:"电机、电器、电子"},
	                {id:3,name:"动力"},
	                {id:4,name:"化工"},
	                {id:5,name:"土木建筑"},
	                {id:6,name:"矿业冶金"},
	                {id:7,name:"轻工纺织粮食"},
	                {id:8,name:"地质水文测绘"},
	                {id:9,name:"运输通讯"},
	                {id:10,name:"管理"},
	                {id:11,name:"理科"},
	                {id:12,name:"农业"},
	                {id:13,name:"林业"},
	                {id:14,name:"医药"},
	                {id:15,name:"文史"},
	                {id:16,name:"外文"},
	                {id:17,name:"财经"},
	                {id:18,name:"政法"},
	                {id:19,name:"体育"},
	                {id:20,name:"文艺"}
	            ],
				planIdData:[],
				isAddOrEdit:true,
                dynamicTags:[],
                selectMajor:"",
                major_num:"",
                num:""

			}
		},
		methods:{
			submitMForm:function(formName){
				this.$refs[formName].validate((valid) =>{
					if (valid) {
                        var Vuethis=this;
                        if(parseInt(this.form.greenNum)>parseInt(this.form.totalNum)){
                            Vuethis.$message({message:"符合绿色通道条件人员数量不能大于总数哦",type:"error"});
                            return false;
                        }
						var Hrrtype=this.$route.params.type; //类型
                		if(Hrrtype=="edit"){Hrrtype="modify"}
						var loading = this.$loading({
							lock: true,
							text: '提交中...',
							spinner: 'el-icon-loading',
							background: 'rgba(0, 0, 0, 0.7)'
						});

                        this.dynamicTags.forEach((e)=>{
                        	this.form['major'+e.id]=e.num;
                        })
                        console.log(this.form);
						var postUrl = (Hrrtype == "modify") ? this.$api.plan.inbjmodify : this.$api.plan.inbjAdd ;
						this.$hrraxios.post(postUrl,this.form)
						.then(function(response){
							loading.close();
							var data=response.data;
							if(data.success==true)
							{
                                Vuethis.$alert("提交成功！",{callback:action=>{
									Vuethis.$router.push({path:'/plan/inbj'});
								}});
							}else{
								Vuethis.$message({message:data.prompt,type:"error"});
							}
						}).catch(function(error){
							loading.close();
							console.log(error);
						})
					} else {
						return false;
					}
				});
			},
			resetMForm:function(formName) {
				this.$refs[formName].resetFields();
				if(this.$route.params.type=="edit"){
					this.initData();
				}else{
					this.dynamicTags=[];
				}
			},
			returnMForm:function(){
				this.$router.go(-1);
			},
			submitMajorForm(formName){
				this.$refs[formName].validate((valid) =>{
					if (valid) {
						var ishas=this.dynamicTags.find((e)=>{return e.id==this.majorform.selectid});
						var marjorname=this.majors.find((e)=>{return e.id==this.majorform.selectid}).name;
						if(ishas){
							this.$message.error("已经添加此专业,不能重复");
						}else{
							this.dynamicTags.push({id:this.majorform.selectid,major:marjorname,num:this.majorform.num})
						}
						this.totle();
					}
					else{
						return false;
					}
				});
			},
			initData:function(){
				var Hrrtype=this.$route.params.type; //类型
				if(Hrrtype!="add"){
					var row=this.$route.meta.row;
					this.dynamicTags=[];
					this.form = row;
					for(var attr in this.form)
					{
						if(attr.indexOf('major')>-1){
							if(this.form[attr]!=null){
								var id=parseInt(attr.replace('major',''));
								var mobj=this.majors.find((e)=>{return e.id==id});
								this.dynamicTags.push({id:id,major:mobj.name,num:this.form[attr]});
							}
						}
					}
				}
				if(Hrrtype=="view"){
					this.title="查看京外调干岗位";
					this.isAddOrEdit=false;
				}
				if(Hrrtype=="edit"){
					this.title="编辑京外调干岗位";
					this.isAddOrEdit=true;

				}
				if(Hrrtype=="add"){
					this.$route.meta.row={}
					this.title="新增京外调干岗位";
					this.isAddOrEdit=true;
				}
					
			},
			totle(){
				this.form.totalNum=0;
				for(let i=0; i<this.dynamicTags.length;i++)
				{
					this.form.totalNum+=parseInt(this.dynamicTags[i].num);
				}
			},
            green(){
                var Vuethis=this;
                if(parseInt(this.form.greenNum)>parseInt(this.form.totalNum)){
                    Vuethis.$message({message:"符合绿色通道条件人员数量不能大于总数哦",type:"error"});
                    return false;
                }
            },
			initParamsData(){
                this.$common.getplanlist(this,"planIdData");
            },
            handleClose(tag) {
                this.dynamicTags.splice(this.dynamicTags.indexOf(tag), 1);
                this.totle();
            },
		},
		created:function(){
			this.initData();
			this.initParamsData();
		}
	}
</script>
<style>
.el-form-inbj{width:100%;}
.line{text-align: center;}
</style>
